/**
 * Remove thinking/reasoning tags from model responses
 * Some models (like minimax) use <think></think> tags instead of
 * standard reasoning format
 * 
 * NOTE: As of Nov 2025, reasoning tokens are captured separately
 * in the backend (message.reasoning field) and should never appear
 * in message.content. This function provides defense-in-depth
 * for edge cases where reasoning might leak into content.
 */
export function cleanMessageContent(content: string, modelUsed?: string): string {
  if (!content) return content;

  // Remove <think>...</think> tags for minimax models
  if (modelUsed?.toLowerCase().includes('minimax')) {
    // Remove think tags and their content
    content = content.replace(/<think>[\s\S]*?<\/think>/gi, '');
    
    // Clean up extra whitespace that might be left
    content = content.replace(/^\s+/, '').trim();
  }

  return content;
}

/**
 * Sanitize message object to ensure reasoning field is never exposed in UI
 * Reasoning tokens are stored in Firestore but should NEVER be displayed
 * 
 * @param message - Message object from Firestore
 * @returns Message with reasoning field removed
 */
export function sanitizeMessageForDisplay<T extends { reasoning?: any }>(
  message: T
): Omit<T, 'reasoning'> {
  const { reasoning, ...sanitized } = message;
  return sanitized;
}

